import React, { useEffect } from 'react';
import { useLocation, Navigate } from 'react-router-dom';
import DeactivatedAccountScreen from '@/components/auth/DeactivatedAccountScreen';
import { useAuth } from '@/contexts/AuthContext';

const DeactivatedPage: React.FC = () => {
  const location = useLocation();
  const { profile } = useAuth();

  const state = (location.state as any) || {};
  const deactivatedAt = state?.deactivatedAt || (profile as any)?.deactivated_at || (profile as any)?.updated_at || null;
  const deactivationReason = state?.deactivationReason || (profile as any)?.deactivation_reason || null;

  useEffect(() => {
    document.title = 'Account Deactivated | Doyence Estimating';
  }, []);

  // If user is not deactivated (edge case), send to dashboard
  if ((profile as any)?.status !== 'deactivated') {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <DeactivatedAccountScreen
      deactivatedAt={deactivatedAt}
      deactivationReason={deactivationReason}
    />
  );
};

export default DeactivatedPage;
